export enum BlackMarkPosition {
    Front = 'Front',
    Back = 'Back'
}